import { render, staticRenderFns } from "./envelope-document-select-modal.vue?vue&type=template&id=544211a1"
import script from "./envelope-document-select-modal.vue?vue&type=script&lang=js"
export * from "./envelope-document-select-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports